/* eslint-disable no-await-in-loop */
/* eslint-disable no-restricted-syntax */
// eslint-disable-next-line no-restricted-syntax
// eslint-disable-next-line no-await-in-loop
import { useEffect, useState } from 'react';
import { useTranslate } from 'hooks/useTranslate';

import { store } from 'redux/store';
import { setModal } from 'modules/_shared/redux/modalActions';
import { getUsers } from 'modules/profile/redux/userActions';
import UserWithAccessRow from './UserWithAccessRow';
import AddUserWithAccess from './AddUserWithAccess';

function UserWithAccess({ user }) {
  const { t } = useTranslate();
  const [rows, setRows] = useState([]);
  const [accountAdmins, setAccountAdmins] = useState([]);

  const getAdmins = async (admins) => {
    try {
      const adminsList = await store.dispatch(
        getUsers({
          usersList: admins,
        })
      );
      setAccountAdmins(adminsList);
    } catch (error) {
      throw new Error(error);
    }
  };

  useEffect(() => {
    if (user?.accountAdmins.length) {
      getAdmins(user?.accountAdmins);
    } else setAccountAdmins([]);
  }, [user?.accountAdmins]);

  useEffect(() => {
    if (accountAdmins) {
      setRows(
        accountAdmins?.map((admin) => (
          <UserWithAccessRow
            admin={admin}
            userId={user['_id']}
            key={admin['_id']}
          />
        ))
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [accountAdmins]);

  return (
    <div className="card-inner card-inner-lg">
      <div className="nk-block-head">
        <div className="nk-block-head-content">
          <h4 className="nk-block-title">
            {t('UsersWithAccessToYourAccount')}
          </h4>
          <div className="nk-block-des">
            <p>{t('UsersWithAccessToYourAccountDescription')}</p>
          </div>
        </div>
      </div>
      <div className="nk-block-head">
        <div className="nk-block-head-content">
          <p
            className="btn btn-success"
            onClick={() => store.dispatch(setModal(<AddUserWithAccess />))}
          >
            {t('AddUsers')}
          </p>
        </div>
      </div>
      <div className="nk-block">
        {rows.length ? (
          <div className="card card-bordered card-preview">
            <table className="nk-tb-list nk-tb-ulist">
              <thead>
                <tr className="nk-tb-item nk-tb-head tb-tnx-head fs-11px">
                  <th className="nk-tb-col">
                    <span>{t('NameAndSurname')}</span>
                  </th>

                  <th className="nk-tb-col tb-col-xl">
                    <span>{t('HighDate')}</span>
                  </th>

                  <th className="nk-tb-col tb-col-xl">
                    <span>{t('LastAccess')}</span>
                  </th>

                  <th className="nk-tb-col tb-col-xl">
                    <span>{t('Email')}</span>
                  </th>

                  <th className="nk-tb-col">
                    <span>{t('AccessLevel')}</span>
                  </th>

                  <th className="nk-tb-col nk-tb-col-tools tb-col-end" />
                </tr>
              </thead>
              <tbody>{rows}</tbody>
            </table>
          </div>
        ) : (
          <></>
        )}
      </div>
    </div>
  );
}

export default UserWithAccess;
